export class UserModal {
    _id?: String;
    name?: String;
    email?: String;
    mobile?: Number;
    department?: String;
    role?: String;
    status?: String;
    createdAt?: Number;
    updatedAt?: Number;
    firstLogin?: Boolean;
    isMfaEnabled?: Boolean;
}